import React from "react";
import Card from "../Card";
import Title from "../Card/Title";
import Subtitle from "../Card/Subtitle";
import Text from "../Card/Text";
import Icon from "../Card/Icon";
import RatingStars from "../../RatingStars";
import { PremiumStoryOverlay } from "./PremiumStory";

const StoryCard = ({
  img,
  title,
  author,
  episodesCount,
  viewsCount,
  subscribersCount,
  rating,
  onClick,
  premium,
  premiumLabel
}) => (
  <div className="t-pt2 t-pr2">
    <Card
      img={img}
      imgOverlay={<PremiumStoryOverlay premium={premium} text={premiumLabel} />}
      onClick={onClick}
    >
      <Title>{title}</Title>
      <Subtitle>{author}</Subtitle>
      <Text className="t-pt2">{episodesCount}</Text>
      <Text className="t-pt2">
        <Icon url="/images/pop-views-icon.png" width="25px" className="t-pr2">
          {viewsCount}
        </Icon>
        <Icon url="/images/pop-subscribers-icon.png">{subscribersCount}</Icon>
      </Text>
      <Text className="t-pt2 t-mb1">
        <RatingStars rating={rating} size="19px" />
      </Text>
    </Card>
  </div>
);

StoryCard.defaultProps = {
  img: "/images/sample_images/sample_jpg.jpg",
  title: "Story 1",
  author: "by Antirex",
  episodesCount: "3 episodes",
  viewsCount: 1700,
  subscribersCount: 13,
  rating: 3.32,
  premium: false,
  premiumLabel: "PREMIUM"
};

export default StoryCard;
